import MemberImportOperateDetail from './member_import_operate_detail.vue'

export default {
    name: 'memberImportOperateDetail',
    path: 'memberImportOperateDetail',
    component: MemberImportOperateDetail
}
